import $ from "jquery";
import { Module } from "wrapper6";

export default class SmoothScroll extends Module {

	ready(app) {

        const ANCHORS = document.querySelectorAll('#main_header a[href*="#"]');

        if (ANCHORS.length) {
            for (let i = 0; i < ANCHORS.length; i++) {
                
                const ANCHOR = ANCHORS[i];

                ANCHOR.addEventListener('click', () => {

                    event.preventDefault();

                    const HREF = ANCHOR.getAttribute('href');
                    if(HREF === '#') return;
                    const EL = document.querySelector(HREF);

                    if (EL) {

                        $('html, body').animate({
                            scrollTop: $(`${HREF}`).offset().top - this.getOffset()
                        }, 1000);

                    }
                })
            }
        }
    }

    /**
     * Get height of header element
     */
    getOffset() {

        const ADMIN_BAR = document.getElementById('wpadminbar');
        const HEADER = document.getElementById('main_header');
        let offset = 0;

        if (HEADER) {

            // Add height of header
            offset = HEADER.getBoundingClientRect().height;
            
            // Add height of admin bar
            if (ADMIN_BAR && this.getScreenWidth() > 600) {
                offset += ADMIN_BAR.getBoundingClientRect().height;
            }

            return offset;
        }

        // Default is 100
        return 100;
    }

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_smooth-scroll.js